import { SkeletonSidePanel } from 'components/secondaryMarket/shared/SidePanel/SkeletonSidePanel';
import { SidePanelTitle, SkeletonSidePanelTitle } from 'components/secondaryMarket/shared/status/SidePanelTitle';
import styled from 'styled-components';

import { ApplyAmendSidePanel } from '../sidePanel/ApplyAmendSidePanel';
import { DoneAmendSidePanel } from '../sidePanel/DoneAmendSidePanel';
import { PendingAmendSidePanel } from '../sidePanel/PendingAmendSidePanel';
import { RejectedAmendSidePanel } from '../sidePanel/RejectedAmendSidePanel';
import type { AmendSidePanelProps } from './sidePanel.connect';

export const StyledDiv = styled.div`
  flex-basis: 40em;
`;

function AmendSidePanelContent({
  tabType,
  applyStatus,
  canApply,
  comment,
  kycDetails,
  kycScore,
  onApply,
  onCommentChanged,
  onDone,
  onNavigateToOrdersBlotter,
  onReset,
  validationErrors,
  backendReports,
  errorMessage,
  applyLabelKey,
  notReadyLabelKey,
  readyLabelKey,
}: Omit<AmendSidePanelProps, 'isLoading' | 'title'>) {
  switch (applyStatus) {
    case 'idle':
      return (
        <ApplyAmendSidePanel
          tabType={tabType}
          canApply={canApply && applyStatus === 'idle' && validationErrors.length === 0}
          comment={comment}
          backendReports={backendReports}
          kycDetails={kycDetails}
          kycScore={kycScore}
          onApply={onApply}
          onCommentChanged={onCommentChanged}
          validationErrors={validationErrors}
          applyLabelKey={applyLabelKey}
          readyLabelKey={readyLabelKey}
          notReadyLabelKey={notReadyLabelKey}
        />
      );
    case 'loading':
      return <PendingAmendSidePanel tabType={tabType} />;
    case 'success':
      return (
        <DoneAmendSidePanel
          onNavigateToOrdersBlotter={onNavigateToOrdersBlotter}
          onDone={onDone}
          validationErrors={validationErrors}
          tabType={tabType}
        />
      );
    case 'error':
      return <RejectedAmendSidePanel onReset={onReset} errorMessage={errorMessage} tabType={tabType} />;
    default:
      return null;
  }
}

export function AmendSidePanel({ isLoading, title, ...otherProps }: AmendSidePanelProps) {
  return (
    <StyledDiv className="card card-bordered h-100 p-3">
      {isLoading ? <SkeletonSidePanelTitle /> : <SidePanelTitle titleMessageKey={title} />}
      {isLoading ? <SkeletonSidePanel /> : <AmendSidePanelContent {...otherProps} />}
    </StyledDiv>
  );
}
